import React from "react";
import {
  RENTDUO_AI_FEATURED_PROMPTS,
  RENTDUO_AI_SUGGESTED_PROMPTS,
} from "../../config/constants";

export default function RentDuoAIAssistant({
  isOpen,
  onClose,
  styles,
  isMobile,
  isPhoneMobile,
  isSuggestedOpen,
  setIsSuggestedOpen,
  messages,
  messagesRef,
  messagesEndRef,
  loading,
  error,
  input,
  setInput,
  onAsk,
}) {
  if (!isOpen) return null;

  return (
    <div style={styles.aiAssistantOverlay} onClick={onClose}>
      <section
        style={{
          ...styles.aiAssistantModal,
          ...(isMobile ? styles.aiAssistantModalMobile : {}),
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <div style={styles.aiAssistantHeader}>
          <div>
            <div style={styles.aiAssistantEyebrow}>AI Rental Advisor</div>
            <h2 style={styles.aiAssistantTitle}>RentDuo AI Assistant</h2>
            <p style={styles.aiAssistantSubtitle}>
              AI-powered rental guidance and property intelligence for safer, more professional RentDuo use.
            </p>
          </div>
          <button
            type="button"
            style={styles.aiAssistantCloseButton}
            onClick={onClose}
          >
            Close
          </button>
        </div>

        <div style={styles.aiAssistantDisclaimer}>
          RentDuo provides general rental information and AI-assisted guidance. RentDuo is not a law firm and does not provide legal advice. Laws vary by location. Contact a licensed attorney or official housing agency for advice about your specific situation.
        </div>

        <div style={styles.aiAssistantPromptPanel}>
          <div style={styles.aiAssistantFeaturedChips}>
            {RENTDUO_AI_FEATURED_PROMPTS.map((item) => (
              <button
                key={item.label}
                type="button"
                style={{
                  ...styles.aiAssistantQuickButton,
                  ...(isMobile ? styles.aiAssistantQuickButtonMobile : {}),
                }}
                onClick={() => onAsk(item.prompt)}
                disabled={loading}
              >
                {item.label}
              </button>
            ))}
          </div>

          <button
            type="button"
            style={styles.aiAssistantSuggestedToggle}
            onClick={() => setIsSuggestedOpen((open) => !open)}
            aria-expanded={isSuggestedOpen}
          >
            <span>Suggested questions</span>
            <span>{isSuggestedOpen ? "Hide" : "Show"}</span>
          </button>

          {isSuggestedOpen ? (
            <div
              style={{
                ...styles.aiAssistantSuggestedGrid,
                ...(isMobile ? styles.aiAssistantSuggestedGridMobile : {}),
              }}
            >
              {RENTDUO_AI_SUGGESTED_PROMPTS.map((prompt) => (
                <button
                  key={prompt}
                  type="button"
                  style={{
                    ...styles.aiAssistantSuggestedButton,
                    ...(isMobile ? styles.aiAssistantSuggestedButtonMobile : {}),
                  }}
                  onClick={() => onAsk(prompt)}
                  disabled={loading}
                >
                  {prompt}
                </button>
              ))}
            </div>
          ) : null}
        </div>

        <div
          style={{
            ...styles.aiAssistantMessages,
            ...(isMobile ? styles.aiAssistantMessagesMobile : {}),
          }}
          ref={messagesRef}
        >
          {messages.map((message, index) => (
            <div
              key={`${message.role}-${index}`}
              style={
                message.role === "user"
                  ? styles.aiAssistantUserBubble
                  : styles.aiAssistantBotBubble
              }
            >
              {message.text}
            </div>
          ))}
          {loading ? (
            <div style={styles.aiAssistantTyping}>RentDuo AI is thinking...</div>
          ) : null}
          <div ref={messagesEndRef} style={styles.aiAssistantMessageEnd} />
        </div>

        {error ? <div style={styles.aiAssistantError}>{error}</div> : null}

        <form
          style={styles.aiAssistantComposer}
          onSubmit={(event) => {
            event.preventDefault();
            onAsk();
          }}
        >
          <textarea
            style={styles.aiAssistantInput}
            value={input}
            onChange={(event) => setInput(event.target.value)}
            placeholder="Ask about a property, review, lease red flag, profile step, or professional response..."
            maxLength={2000}
            rows={2}
          />
          <button
            type="submit"
            style={{
              ...styles.primaryButton,
              marginTop: 0,
              minWidth: isPhoneMobile ? "100%" : 110,
            }}
            disabled={loading}
          >
            {loading ? "Asking..." : "Ask"}
          </button>
        </form>
      </section>
    </div>
  );
}
